import type { CrmEnrichmentJobObject } from "app/pages/sales-intelligence/modules/crm-enrichment/types/types";

export const HS_OBJECTS_OPTIONS: readonly CrmEnrichmentJobObject[] = ["company", "contact"];
